import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { MapPin, Clock, Phone, User, Navigation, AlertCircle } from 'lucide-react';

export default function DeliveryPointPublic() {
  const { token } = useParams();
  const [point, setPoint] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/delivery-point/${token}`)
      .then((r) => setPoint(r.data))
      .catch(() => setError(true));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-neutral-100 flex items-center justify-center p-6">
        <div className="text-center" data-testid="point-error">
          <AlertCircle className="w-10 h-10 text-neutral-400 mx-auto mb-3" />
          <p className="text-neutral-700">Ссылка недействительна</p>
        </div>
      </div>
    );
  }

  if (!point) {
    return <div className="min-h-screen bg-neutral-100 flex items-center justify-center text-neutral-500">Загрузка…</div>;
  }

  const fullAddress = [point.address_line, point.city].filter(Boolean).join(', ');
  const mapsUrl = `https://2gis.kz/almaty/search/${encodeURIComponent(fullAddress)}`;

  return (
    <div className="min-h-screen bg-neutral-100 py-8 px-4">
      <div className="max-w-md mx-auto bg-white rounded-2xl shadow-sm overflow-hidden" data-testid="point-card">
        <div className="bg-emerald-800 text-white px-5 py-4">
          <p className="text-xs uppercase tracking-widest text-emerald-200">Точка доставки</p>
          <h1 className="text-2xl font-semibold leading-tight mt-1">{point.label || point.client_name}</h1>
          {point.label && <p className="text-sm text-emerald-100 mt-0.5">{point.client_name}</p>}
        </div>

        <div className="px-5 py-5 space-y-4 text-neutral-800">
          <div className="flex gap-3">
            <MapPin className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
            <div>
              <p className="font-medium" data-testid="point-address">{point.address_line}</p>
              {point.city && <p className="text-sm text-neutral-500">{point.city}{point.district ? `, ${point.district}` : ''}</p>}
            </div>
          </div>

          {(point.open_time || point.close_time) && (
            <div className="flex gap-3">
              <Clock className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
              <div>
                <p className="font-medium" data-testid="point-hours">
                  {point.open_time || '—'} – {point.close_time || '—'}
                </p>
                <p className="text-sm text-neutral-500">Часы работы точки</p>
              </div>
            </div>
          )}

          {point.contact_person && (
            <div className="flex gap-3">
              <User className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
              <p className="font-medium">{point.contact_person}</p>
            </div>
          )}

          {point.phone && (
            <a href={`tel:${point.phone.replace(/\s/g, '')}`} className="flex gap-3 items-center">
              <Phone className="w-5 h-5 text-emerald-700 shrink-0" />
              <span className="font-medium text-emerald-800 underline" data-testid="point-phone">{point.phone}</span>
            </a>
          )}

          {point.driver_note && (
            <div className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-sm text-amber-900"
                 data-testid="point-note">
              {point.driver_note}
            </div>
          )}

          <a
            href={mapsUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center gap-2 w-full bg-emerald-800 hover:bg-emerald-900 transition-colors text-white rounded-xl py-3 font-medium"
            data-testid="point-map-btn"
          >
            <Navigation className="w-4 h-4" /> Открыть в 2ГИС
          </a>
        </div>

        <p className="text-center text-xs text-neutral-400 pb-5">Ainanan · информация для доставки</p>
      </div>
    </div>
  );
}
